import { CallState, LoadingState } from '@lcs/shared/api';
import { Action, createReducer } from '@ngrx/store';

export const editMailboxPinFeatureKey = 'editMailboxPin';

export interface EditMailboxPinState {
   callState: CallState;
}

export const initialState: EditMailboxPinState = {
   callState: LoadingState.Init,
};

const editMailboxPinReducer = createReducer(initialState);

export function reducer(state: EditMailboxPinState | undefined, action: Action) {
   return editMailboxPinReducer(state, action);
}
